export default __webpack_public_path__ + "static/media/scanner_beep.3f52d834.mp3";